import { useState, useEffect, ReactNode } from 'react';

interface NetflixGradientBackgroundProps {
  children: ReactNode;
  interval?: number;
  transitionDuration?: number;
}

const NetflixGradientBackground: React.FC<NetflixGradientBackgroundProps> = ({
  children,
  interval = 5000,
  transitionDuration = 4
}) => {
  const [currentGradient, setCurrentGradient] = useState(0);

  const gradients = [
    'linear-gradient(330.93deg, #dc1721 -7.96%, rgba(68, 18, 77, 0.5) 42.31%, transparent 81.62%)',
    'linear-gradient(330.93deg, #ffb234 -6.5%, rgba(141, 42, 19, 0.5) 42.31%, transparent 81.62%)',
    'linear-gradient(330.93deg, #10b892 0.43%, rgba(32, 28, 113, 0.5) 42.31%, rgba(5, 0, 0, 0) 81.62%)',
    'linear-gradient(330.93deg, #4d61fe -7.96%, rgba(44, 7, 37, 0.5) 42.31%, rgba(5, 0, 0, 0) 81.62%)'
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentGradient((prev) => (prev + 1) % gradients.length);
    }, interval);

    return () => clearInterval(intervalId);
  }, [gradients.length, interval]);

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'black'
    }}>
      {gradients.map((gradient, index) => (
        <div
          key={index}
          style={{
            position: 'absolute',
            inset: 0,
            background: gradient,
            opacity: index === currentGradient ? 1 : 0,
            transition: `opacity ${transitionDuration}s ease`,
            zIndex: 1
          }}
        />
      ))}
      
      <div style={{
        position: 'absolute',
        inset: 0,
        zIndex: 2,
        overflowY: 'auto',
        height: '100vh'
      }}>
        {children}
      </div>
    </div>
  );
};

export default NetflixGradientBackground;